export default theme => ({
    root: {},
    vehicleDetail: {
      margin: theme.spacing(1)
    },
  });
  